// TABSLAYOUT1 (docs/build-briefs/TABSLAYOUT1-open-tickets.md section 6): how long an open tab has been open, as
// the text on its age badge. Pure so the boundaries are unit tested.

export interface TabAge {
  text: string;
  /** True at 60 minutes or more: the warning badge, and the Over 1 hr count. */
  aging: boolean;
  /** True at 24 hours or more: the danger badge. */
  stale: boolean;
}

const MINUTES_PER_HOUR = 60;
const MINUTES_PER_DAY = 24 * MINUTES_PER_HOUR;

/** Whole minutes open, rounded to the nearest minute and never negative. */
export function tabAgeInMinutes(createdAtIso: string, nowMs: number = Date.now()): number {
  return Math.max(0, Math.round((nowMs - new Date(createdAtIso).getTime()) / 60_000));
}

/** "48 min" under an hour; "1 hr 17 min" (or "2 hr") from an hour; "N days" (whole days, rounded down) from 24 hours. */
export function formatTabAge(minutes: number): TabAge {
  if (minutes < MINUTES_PER_HOUR) {
    return { text: `${minutes} min`, aging: false, stale: false };
  }
  if (minutes < MINUTES_PER_DAY) {
    const hours = Math.floor(minutes / MINUTES_PER_HOUR);
    const remainder = minutes % MINUTES_PER_HOUR;
    return {
      text: remainder === 0 ? `${hours} hr` : `${hours} hr ${remainder} min`,
      aging: true,
      stale: false,
    };
  }
  const days = Math.floor(minutes / MINUTES_PER_DAY);
  return { text: days === 1 ? "1 day" : `${days} days`, aging: true, stale: true };
}
